<template>
  <div class="vip">
    <!--<div class="vip-scroll">-->
    <!--<VipHead :isBuy="isBuy"  @showChoice="showChoice">-->
    <!--<template slot="userPic">-->
    <!--<img :src="userPic" alt="" >-->
    <!--</template>-->
    <!--<template slot="userName">-->
    <!--{{userName | lengthCut(6)}}-->
    <!--</template>-->
    <!--<template slot="endDate">-->
    <!--{{ endDate | dateFilter}}-->
    <!--</template>-->
    <!--</VipHead>-->
    <img src="./images/activity/01.jpg" alt="">
    <img src="./images/activity/02.png" alt="">
    <!--<div class="vip-rule" @click="showNotice()">-->
    <!--<img src="./images/main/icon-rule.png" alt="">-->
    <!--</div>-->
    <div class="vip-courses">
      <img src="./images/activity/bg-2.png" alt="">
      <div class="vip-courses-main">
        <img src="./images/activity/course-title.png" class="vip-title" alt="">
        <ul class="vip-courses-main-list">
          <li class="vip-courses-main-item"
              @click="topage(item.id)"
              v-for="(item) in workList"
              :key="item.id">
            <img v-if="item.courseImage" :src="item.courseImage" alt="">
            <img v-else src="//edu-wps-cn.ks3-cn-beijing.ksyun.com/static_file/pictures/teachers/16e6d2acb36362bf7c2025d932699b56.png" alt="">
            <div>
              <span>{{item.price}}</span>
              <img src="./images/main/icon-vip-free.png" alt="">
              <img src="./images/main/icon-vip-right.png" alt="">
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="vip-teachers">
      <img src="./images/activity/teacher-title.png" alt="" class="vip-title">
      <ul class="vip-teachers-list">
        <li class="vip-teachers-item"
            :key="item.id"
            @click="topage(item.id)"
            v-for="(item) in teacherList">
          <img v-if="item.image" :src="item.image" alt="">
          <img v-else src="//edu-wps-cn.ks3-cn-beijing.ksyun.com/static_file/pictures/teachers/16e6d2acb36362bf7c2025d932699b56.png" alt="">
          <div class="vip-teachers-item-bottom">
            <span>{{item.teacherName | lengthCut}}</span>
            <img src="./images/activity/icon-vip-right-2.png" alt="">
          </div>
        </li>
      </ul>
    </div>
    <div class="vip-popular" ref="popular">
      <div class="vip-popular-main">
        <img src="./images/activity/popular-title.png" class="vip-title" alt="">
        <ul class="vip-popular-main-list">
          <li class="vip-popular-main-item"
              v-for="(item, index) in popularList"
              :key="item.id"
              @click="topage(item.id)"
              ref="popularItem">
            <div class="icon-hot" v-if="index < 3">
              <img src="./images/main/icon-vip-hot.png" alt="">
            </div>
            <div v-else class="icon-hot">
              <img src="./images/main/icon-vip-rec.png" alt="">
            </div>
            <img v-if="item.courseImage" :src="item.courseImage" alt="">
            <img v-else src="//edu-wps-cn.ks3-cn-beijing.ksyun.com/static_file/pictures/teachers/16e6d2acb36362bf7c2025d932699b56.png" alt="">
            <div class="vip-popular-main-item-desc">
              <div class="vip-popular-main-item-desc">
                <h1>{{item.title}}</h1>
                <p>累计售出<span>{{item.count}}</span>份</p>
                <div class="price">
                  <span>{{item.price}}</span>
                  <img src="./images/main/icon-vip-free-3.png" alt="">
                  <img src="./images/main/icon-vip-right.png" alt="">
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="vip-book">
        <img src="./images/activity/bg-4.png" class="vip-book-bg" alt="">
        <div class="vip-book-main">
          <img src="./images/activity/book-title.png" alt="" class="vip-title">
          <ul class="vip-book-main-list">
            <li class="vip-book-main-item"
                v-for="(item) in bookList"
                @click="topage(item.id)"
                :key="item.id">
              <!--<div-->
              <!--v-if="item.courseImage"-->
              <!--class="vip-book-main-item-image"-->
              <!--:style="{'background-image':'url('+item.courseImage+')'}"></div>-->
              <img v-if="item.image" :src="item.image" alt="">
              <img v-else src="//edu-wps-cn.ks3-cn-beijing.ksyun.com/static_file/pictures/teachers/16e6d2acb36362bf7c2025d932699b56.png" alt="">
              <div class="vip-book-main-item-desc">
                <p>《{{item.title | lengthCut}}》</p>
                <p>￥{{item.price}}</p>
                <img src="./images/main/icon-vip-free-2.png" alt="">
              </div>
            </li>
          </ul>
        </div>
      </div>

    </div>
    <img class="vip-desc" src="./images/activity/04.png" alt="">
    <div class="vip-button" v-if="signStatus !== 2">
      <div class="vip-button-price" @click="showNotice">
        <!--<img src="./images/activity/icon-price.png" alt="">-->
        <p>{{firstPrice}}</p>
        <p class="price" >第二个月自动续费￥{{price}}/月</p>
      </div>
      <div @click="buy()" class="vip-button-buy"></div>
    </div>
    <div v-else class="vip-button hasBuy-btn" @click="torecommend()"></div>
    <!--<VipChoice-->
    <!--:cardList="cardList"-->
    <!--:bonus="bonus"-->
    <!--:isBuy="isBuy"-->
    <!--:signStatus="signStatus"-->
    <!--@closeCardChoice="closeCardChoice"-->
    <!--v-if="choiceCardShow"/>-->
    <Notice ref="notice">
      <div class="notice-main">
        <h1>自动续费说明</h1>
        <ol>
          <li>到期前一天自动为您续费</li>
          <li>扣款前消息通知，完全透明</li>
          <li>尊享超低价优惠</li>
          <li>可随时取消自动续费服务，取消后不再自动续费</li>
        </ol>
        <div class="notice-main-btn" @click="$refs.notice.close()">好的</div>
        <p @click="$router.push('/vipRules')">查看连续包月服务条款</p>
      </div>
    </Notice>
  </div>
  <!--</div>-->
</template>

<script>
  import './style.scss'
  import keys from 'lodash.keys'
  import os from '@edu-fe/os'
  import api from '@edu-fe/api'
  import module from '../../modules/vip/vip'
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
  // import barBus from '../../bar/bus'
  // import VipHead from '../../components/Vip/VipHead'
  // import VipChoice from '../../components/Vip/VipChoice'
  // import RecommendShowcase from '../../components/Recommend/RecommendShowcase.vue'
  import Notice from '../../components/Notice'
  // import barBus from '../../bar/bus'
  import login from "@/utils/login";
  import SignInfo from "../../lib/signInfo"
  const INFO_LIST = ['default', 'bookList', 'workList', 'teacherList', 'popularList']
  export default {
    data () {
      return {
        choiceCardShow: false,
        bookList: [],
        workList: [],
        teacherList: [],
        popularList: [],
        firstPrice: [],
        price: []
      }
    },
    computed: {
      ...mapState(module.name, keys(module.state())),
      ...mapGetters(module.name, keys(module.getters)),
      ...mapState(['vipOperationList']),
    },
    watch: {
      vipOperationList: {
        handler (list) {
          if (!list.length) return
          list.map(val => {
            this[INFO_LIST[val.type]] = val.vipShowCourseList
          })
        },
        deep: true,
        immediate: true
      },
      cardList: {
        handler (val) {
          if (!val.length) return
          this.firstPrice = val[0].firstPrice
          this.price =  val[0].price
        },
        immediate: true,
        deep: true
      }
    },
    methods: {
      ...mapMutations(module.name, keys(module.mutations)),
      ...mapActions(module.name, keys(module.actions)),
      closeCardChoice () {
        this.choiceCardShow = false
      },
      showChoice () {
        this.choiceCardShow = !this.choiceCardShow
      },
      showNotice () {
        this.$refs.notice.show()
      },
      torecommend () {
        this.$router.push('recommend')
        // barBus.$emit('setTitle', '发现好课')
      },
      topage (courseId) {
        this.$router.push({
          path: '/sign-up',
          query: {
            courseId,
            from: 'H5_vip_card',
          }
        })
      },
      async buy () {
        await login.login()
        SignInfo.sign({
          cardType: 1,
          from: this.$route.query.from
        })
      },
    },
    filters: {
      dateFilter (val) {
        if (!val)  {
          return '每天不到2元钱，畅学180+精品好课'
        } else {
          return `${moment(val).format('YYYY年MM月DD日')}过期`
        }
      },
      lengthCut (val, len = 4) {
        if (!val) return ''
        return val.length > len ? `${val.slice(0,len)}..`:val
      }
    },
    beforeCreate () {
      this.$store.registerModule(module.name, module)
    },
    created () {
      this.init()
      // barBus.$emit('hideBar')
    },
    mounted () {
      window.scrollTo(0, 0)
    },
    beforeDestroy () {
      this.$store.unregisterModule(module.name)
    },
    components: {
      // VipHead,
      // VipShowCase: RecommendShowcase,
      // VipChoice,
      Notice
    }
  }
</script>
<style lang="scss" scoped>
  @import "./style.scss";
  .vip {
    background: #ec7075;
    &-courses {
      margin-bottom: 0;
      &-main {
        top: 50%;
        transform: translateY(-55%);
      }
    }
    &-book {
      &-main {
        &-item {
          &-desc {
            background: rgba(#F96942,.7);
            > p {
              color: #fff;
              &:nth-of-type(2) {
                color: #F5EED6;
                &:before {
                  background: #F5EED6;
                }
              }
            }
          }
        }
      }
    }
    &-desc {
      top: rem(-50);
    }
    &-teachers {
      background: url("images/activity/bg-3.png") no-repeat;
      background-size: cover;
      &-item {
        &-bottom {
          background: #fff;
          color: #3B251C;
        }
      }
    }
    &-popular {
      background: url("images/activity/bg-5.png") ;
      background-size: cover;
      &:before {
        background: url("images/activity/icon-tip-t-holder.png") no-repeat;
        background-size: contain;
        top: rem(85);
      }
      &:after {
        background: url("images/activity/icon-tip-t.png") no-repeat;
        background-size: contain;
        left: 49.5%;
      }
    }
    .learn-button {
      width: 100%;
      height: rem(140);
      font-size: rem(60);
      position: fixed;
      bottom: 0;
      left: 0;
      color: #fff;
      background: #5a0e0d;
      z-index: 99;
      text-align: center;
      line-height: rem(140);
    }
    &-button {
      background: url('images/activity/vip-button.png');
      background-size: cover;
      height: rem(140);
      &-price {
        position: absolute;
        top: 50%;
        left: rem(24);
        transform: translateY(-50%);
        line-height: 1;
        > p {
          &:first-child {
            &:before {
              content: '￥';
              font-size: rem(42);
            }
            text-align: left;
            background: linear-gradient(to bottom,transparent 0%, #fff 1%, #FFE19C);
            -webkit-background-clip: text;
            color: transparent;
            font-size: rem(80);
            font-weight: bold;
          }
        }
        .price {
          font-size: rem(18);
          color: #FFECEC;
        }
      }

      &-buy {
        position: absolute;
        width: rem(252);
        height: rem(94);
        right: rem(20);
        top: rem(23);
      }
    }
    .hasBuy-btn {
      background-image: url('images/activity/hasBuy.jpg')
    }
  }
</style>
